export default "__VITE_ASSET__0f2fc636__"